import PaymentCodesList from './payment-codes-list-component';
import PaymentCodesListService from './payment-codes-list-service';
import HierarchicalPaymentCodes from './hierarchical-payment-codes/hierarchical-payment-codes-module';
import UomPaymentCodes from './uom-payment-codes/uom-payment-codes-module';
import './payment-codes-list.scss';
const MODULE_NAME = 'Trip.payment-codes.list';
const module = angular.module(MODULE_NAME, [
    HierarchicalPaymentCodes,
    UomPaymentCodes,
])
    .service(PaymentCodesListService.SERVICE_NAME, PaymentCodesListService)
    .directive(PaymentCodesList.DIRECTIVE_NAME, PaymentCodesList);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/payment-codes-list-module.js